import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
//const userData = JSON.parse(localStorage.getItem('auth'))
//const existingAbility = userData ? userData.ability : null
let existingAbility = []

try {
    const userdata = JSON.parse(localStorage.getItem('auth'))

    if (userdata && userdata.isRestaurant === false) {
        existingAbility = [
            { action: 'manage', subject: 'restaurants' },
            { action: 'manage', subject: 'profile' },
            { action: 'manage', subject: 'settings' },
            { action: 'manage', subject: 'login' }
        ]
    } else {
        existingAbility = [
            { action: 'manage', subject: 'orders' }, 
            { action: 'manage', subject: 'menu' }, 
            { action: 'manage', subject: 'items' }, 
            { action: 'manage', subject: 'tables' }, 
            { action: 'manage', subject: 'waiters' },
            { action: 'manage', subject: 'profile' },
            { action: 'manage', subject: 'settings' },
            { action: 'manage', subject: 'login' }
        ]
    }
} catch {
    existingAbility = [
        { action: 'manage', subject: 'orders' }, 
        { action: 'manage', subject: 'menu' }, 
        { action: 'manage', subject: 'items' }, 
        { action: 'manage', subject: 'tables' }, 
        { action: 'manage', subject: 'waiters' },
        { action: 'manage', subject: 'profile' },
        { action: 'manage', subject: 'settings' },
        { action: 'manage', subject: 'login' }
    ]
}

export default new Ability(existingAbility || initialAbility)
